import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${API}/admin/login`,
        { password },
        { withCredentials: true }
      );

      toast.success("Login successful!");
      navigate("/admin/submissions");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A1128] to-[#1a2847] flex items-center justify-center px-4">
      <Card className="w-full max-w-md glass-card border-0 shadow-2xl">
        <CardHeader className="space-y-2 text-center">
          <div className="mx-auto mb-6">
            <img 
              src="/coverdocket-logo.png" 
              alt="CoverDocket Logo" 
              className="h-24 w-auto mx-auto"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-[#0A1128]">
            Admin Login
          </CardTitle>
          <CardDescription className="text-base">
            Enter your password to access the admin dashboard
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-medium">
                Password
              </Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="h-11"
                autoComplete="current-password"
              />
            </div>

            <Button
              type="submit"
              data-testid="admin-login-button"
              disabled={loading}
              className="w-full h-12 text-base btn-primary font-medium"
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;